import { notifications as y } from "@mantine/notifications";
import m from "react";
import { t as s } from "./vanilla-BMQk9Zav.mjs";
import { c as d, T as w } from "./createReactComponent-mYmqlnjV.mjs";
import { z as n } from "zod";
import { PhoneNumberUtil as b } from "google-libphonenumber";
var C = d(
  "alert-circle-filled",
  "IconAlertCircleFilled",
  [
    [
      "path",
      {
        d: "M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm.01 13l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm-.01 -8a1 1 0 0 0 -.993 .883l-.007 .117v4l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z",
        fill: "currentColor",
        key: "svg-0",
        strokeWidth: "0"
      }
    ]
  ]
), k = d(
  "circle-check-filled",
  "IconCircleCheckFilled",
  [
    [
      "path",
      {
        d: "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-1.293 5.953a1 1 0 0 0 -1.32 -.083l-.094 .083l-3.293 3.292l-1.293 -1.292l-.094 -.083a1 1 0 0 0 -1.403 1.403l.083 .094l2 2l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32z",
        fill: "currentColor",
        key: "svg-0",
        strokeWidth: "0"
      }
    ]
  ]
), I = d("circle-x-filled", "IconCircleXFilled", [
  [
    "path",
    {
      d: "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-6.489 5.8a1 1 0 0 0 -1.218 1.567l1.292 1.293l-1.292 1.293l-.083 .094a1 1 0 0 0 1.497 1.32l1.293 -1.292l1.293 1.292l.094 .083a1 1 0 0 0 1.32 -1.497l-1.292 -1.293l1.292 -1.293l.083 -.094a1 1 0 0 0 -1.497 -1.32l-1.293 1.292l-1.293 -1.292l-.094 -.083z",
      fill: "currentColor",
      key: "svg-0",
      strokeWidth: "0"
    }
  ]
]), S = d(
  "info-circle-filled",
  "IconInfoCircleFilled",
  [
    [
      "path",
      {
        d: "M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z",
        fill: "currentColor",
        key: "svg-0",
        strokeWidth: "0"
      }
    ]
  ]
), x = { root: "_1u5mhob0" };
const v = {
  warning: s.colors.warning[1],
  info: s.colors.positive[1],
  error: s.colors.negative[1],
  neutral: s.colors.neutral[2]
}, M = {
  warning: /* @__PURE__ */ m.createElement(C, null),
  info: /* @__PURE__ */ m.createElement(k, null),
  error: /* @__PURE__ */ m.createElement(I, null),
  neutral: /* @__PURE__ */ m.createElement(
    S,
    {
      color: "black",
      stroke: "black",
      style: { color: "black", stroke: "black", fill: "black" }
    }
  )
}, P = (e, { message: l, duration: t }) => {
  y.show({
    withCloseButton: !1,
    autoClose: t ?? 3e3,
    message: /* @__PURE__ */ m.createElement(w, { c: e === "neutral" ? "black" : "neutral.0", size: "md" }, l),
    color: "transparent",
    icon: M[e],
    loading: !1,
    classNames: { root: x.root },
    styles: {
      root: { backgroundColor: v[e], width: "fit-content" },
      description: { color: s.colors.neutral[0] },
      icon: {
        marginLeft: 0,
        marginRight: s.spacing.sm,
        width: "20px",
        height: "20px"
      }
    }
  });
}, N = (e) => {
  const l = new Date(e), t = (/* @__PURE__ */ new Date()).toISOString().slice(0, -1), o = new Date(t), r = Math.abs(o.getTime() - l.getTime()), a = 5 * 60 * 1e3;
  return r > a;
};
async function p(e, l = 3) {
  try {
    const t = await fetch(e);
    if (!t.ok)
      throw new Error(`Failed to fetch stylesheet: ${t.statusText}`);
    return await t.text();
  } catch (t) {
    return l > 0 ? (console.warn(`Retry fetching stylesheet (${l} attempts left):`, e), p(e, l - 1)) : (console.warn("Could not fetch stylesheet:", e, t), "");
  }
}
function g(e) {
  const l = window.getComputedStyle(e);
  let t = "";
  for (let o = 0; o < l.length; o++) {
    const r = l[o], a = l.getPropertyValue(r);
    a && (t += `${r}: ${a}; `);
  }
  t && e.setAttribute("style", t), e.children.length > 0 && [...e.children].forEach((o) => g(o));
}
async function q(e, l) {
  const t = document.querySelector(`#${e}`);
  if (!t)
    return console.error("No element found with id:", e), null;
  const o = t.cloneNode(!0), r = [], a = [];
  document.querySelectorAll("style").forEach((u) => {
    r.push(u.textContent);
  }), document.querySelectorAll('link[rel="stylesheet"]').forEach(async (u) => {
    const { href: f } = u;
    f && a.push(p(f));
  });
  const i = await Promise.all(a);
  r.push(...i), g(o);
  const c = [];
  return document.querySelectorAll('link[rel="stylesheet"][href*="fonts"]').forEach((u) => {
    c.push(u.outerHTML);
  }), `
      <!DOCTYPE html><html><head><meta charset="UTF-8">${c.join("")}
      <title>${l ?? "Document.pdf"}</title>
      <style>${r.join(" ")}</style></head><body>${o.outerHTML}</body></html>
  `.replaceAll(`
`, "").replaceAll(/\s+/g, " ").trim();
}
function V(e, l) {
  const t = e.lastIndexOf("."), o = t !== -1, r = o ? e.slice(0, t) : e, a = o ? e.slice(t) : "";
  if (l.includes(e)) {
    let i = 1, c = `${r} (${i})${a}`;
    for (; l.includes(c); )
      i += 1, c = `${r} (${i})${a}`;
    return c;
  }
  return e;
}
const h = b.getInstance();
function $(e, l = "AE") {
  try {
    const t = h.parse(e, l), o = h.isValidNumber(t), r = h.format(t, 1);
    return {
      isValid: o,
      formatted: r,
      // E.164 format (+97157XXXXXXX)
      countryCode: t.getCountryCode(),
      nationalNumber: t.getNationalNumber(),
      type: h.getNumberType(t)
      // Type of number (mobile, landline, etc.)
    };
  } catch {
    return { isValid: !1 };
  }
}
const L = n.union([
  n.string().email().max(100),
  n.literal(""),
  n.null()
]), R = n.union([
  n.string().regex(
    /^(https?:\/\/(www\.)?|www\.)([\w#%+.:=@~-]+)+((\.[A-Za-z]{2,3})+)(\/(.)*)?(\?(.)*)?/,
    "Invalid url"
  ),
  n.string().regex(
    /^([\w#%+.:=@~-]+)+((\.[A-Za-z]{2,3})+)(\/(.)*)?(\?(.)*)?/,
    "Invalid url"
  ),
  n.literal(""),
  n.null()
]), U = n.string().optional().nullable(), W = (e) => n.string().max(e).optional().nullable(), H = n.number().optional().nullable(), O = (e) => n.number().max(e).optional().nullable(), j = (e) => n.union([n.enum(e), n.literal(""), n.null()]).optional(), X = n.string().refine(
  (e) => {
    if (!e)
      return !0;
    try {
      const l = $(e);
      return (l == null ? void 0 : l.isValid) ?? !1;
    } catch {
      return !1;
    }
  },
  { message: "Invalid phone number format" }
).optional().nullable();
export {
  X as a,
  L as b,
  q as c,
  H as d,
  j as e,
  W as f,
  V as g,
  N as i,
  O as n,
  $ as p,
  U as s,
  P as t,
  R as u
};
